module.exports = __webpack_public_path__ + "static/langojango-czech-language-phrasebook-4633011124840a4a15d854315ae36fe8.png";